<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.1976 6.29289C8.58812 6.68342 8.58812 7.31658 8.1976 7.70711L6.41456 9.48988L15.7664 9.48951C18.6568 9.48951 20.9997 11.8323 20.9997 14.7228C20.9997 17.6132 18.6571 19.9569 15.7664 19.9569H12.2824C11.7301 19.9569 11.2824 19.5092 11.2824 18.9569C11.2824 18.4046 11.7301 17.9569 12.2824 17.9569H15.7664C17.5521 17.9569 18.9997 16.5091 18.9997 14.7228C18.9997 12.9369 17.5523 11.4895 15.7664 11.4895C15.7664 11.4895 15.7665 11.4895 15.7664 11.4895L6.41399 11.4899L8.19759 13.2736C8.58812 13.6641 8.58812 14.2973 8.1976 14.6878C7.80708 15.0784 7.17391 15.0784 6.78339 14.6878L3.29288 11.1971C2.90237 10.8065 2.90237 10.1734 3.29289 9.78286L6.78338 6.29289C7.17391 5.90237 7.80707 5.90237 8.1976 6.29289Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
